import React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import { HStack, Link, VStack } from "@chakra-ui/react";

import {
  IconTagFailed,
  IconTagPassed,
  IconTagTime,
  IconTagUser,
} from "@components";
import { BooleanString, booleanStringToBoolean } from "@constants";
import { TimelineTypes } from "../timelineTypes";

type EventDetailsProps = {
  passed?: BooleanString;
  completedBy: string;
  completedOn: Date;
  item: TimelineTypes;
  moduleId?: string;
};

function EventDetails({
  passed,
  completedBy,
  completedOn,
  item,
  moduleId = "",
}: EventDetailsProps) {
  const passFailTag =
    passed === undefined ? null : booleanStringToBoolean(passed) ? (
      <IconTagPassed />
    ) : (
      <IconTagFailed />
    );
  return (
    <VStack alignItems="stretch">
      <HStack gap="8px" justifyContent="flex-start">
        {passFailTag}
        <IconTagUser name={completedBy} />
        <IconTagTime time={completedOn} />
      </HStack>
      {item === "user" && moduleId ? (
        <Link as={ReactRouterLink} to={`/modules/${moduleId}`}>
          Module: {moduleId}
        </Link>
      ) : null}
    </VStack>
  );
}

export { EventDetails };
